import { Squares2X2Icon, TableCellsIcon } from '@heroicons/react/24/outline';
import * as RadixToggleGroup from '@radix-ui/react-toggle-group';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import { setAssignmentManagementDisplayMode } from './assignmentManagement.slice';
import { AssignmentManagementDisplayMode } from './assignmentManagement.slice';

export const AssignmentManagementDisplayToggle = () => {
  const dispatch = useAppDispatch();
  const displayMode = useAppSelector(
    (state) => state.assignmentManagement.displayMode
  );

  const handleDisplayModeChange = (value: string) => {
    if (!value || value === displayMode) return;

    dispatch(setAssignmentManagementDisplayMode(value));
  };

  const baseClasses =
    'bg-white text-base h-[32px] w-[32px] text-xl flex items-center justify-center';
  const activeClass =
    'data-[state=on]:bg-mint data-[state=on]:text-white border-w-3';
  const inactiveClass =
    'data-[state=off]:bg-gray-200 data-[state=off]:text-base';

  return (
    <RadixToggleGroup.Root
      type="single"
      value={displayMode}
      onValueChange={handleDisplayModeChange}
      className="inline-flex shadow-sm"
    >
      <RadixToggleGroup.Item
        className={`${baseClasses} ${activeClass} ${inactiveClass} rounded-l-md`}
        value={AssignmentManagementDisplayMode.PLAN_BY}
      >
        <Squares2X2Icon
          data-testid={`assignment-management-display-mode-item-${AssignmentManagementDisplayMode.PLAN_BY}`}
          className="h-5 w-5"
        />
      </RadixToggleGroup.Item>
      <RadixToggleGroup.Item
        className={`${baseClasses} ${activeClass} ${inactiveClass} rounded-r-md`}
        value={AssignmentManagementDisplayMode.DATAGRID}
      >
        <TableCellsIcon
          data-testid={`assignment-management-display-mode-item-${AssignmentManagementDisplayMode.DATAGRID}`}
          className="h-5 w-5"
        />
      </RadixToggleGroup.Item>
    </RadixToggleGroup.Root>
  );
};
